/**
 * Open Dental `patient.PatStatus` → a label a dental office would recognise.
 *
 * Tx Presenter serves patients of any status (the detail endpoint dropped its
 * `PatStatus = 0` gate on 2026-08-04 — see tx-presenter-service/tx-presenter.js),
 * so the drawer and the Tx Plans dispatcher badge anything non-Active to make the
 * patient's state in OD visible before a TC sends or presents a plan.
 */
export const PAT_STATUS_LABELS = {
  0: 'Active',
  1: 'Non-Patient',
  2: 'Inactive',
  3: 'Archived',
  4: 'Deleted',
  5: 'Deceased',
  6: 'Prospective',
};

/**
 * Label for the status badge, or null when no badge should render.
 *
 * Null for Active (0) — the normal case needs no badge — and null for
 * missing/unknown values. Missing matters: a frontend deployed ahead of the
 * backend gets no `patStatus` at all, and must simply show nothing rather than
 * break. Unknown ints are a data anomaly; a raw "Status 7" in front of a practice
 * is noise, so they stay silent too.
 */
export function patientStatusLabel(patStatus) {
  if (patStatus === undefined || patStatus === null || patStatus === '') return null;
  const label = PAT_STATUS_LABELS[Number(patStatus)];
  return label && label !== 'Active' ? label : null;
}
